function equalizeHeights() {
        let textElements = document.querySelectorAll(".product-item__product-title.fs-product-card-title");
        let maxHeight = 0;

        // Reset heights to auto to get natural height
        textElements.forEach(el => el.style.height = "auto");

        // Encontrar la altura máxima
        textElements.forEach(el => {
            let height = el.offsetHeight;
            if (height > maxHeight) {
                maxHeight = height;
            }
        });
        // Aplicar la altura máxima a todos los elementos
        textElements.forEach(el => el.style.height = maxHeight + "px");
    }


function redirectOnClickVariant()
{
  const botones = document.querySelectorAll('.dynamic-variant-button');
  if(botones.length <= 0)
  {
    return;
  }
  botones.forEach(function (boton) {
    boton.addEventListener('click', function (e) {
      e.preventDefault();
      const url = boton.getAttribute('data-redirect');
      if(url)
      {
        window.location.href = url;  
      }
    });
  });
}

document.addEventListener("DOMContentLoaded", () => {
  const currentPath = window.location.pathname;
  const customFormPath = localStorage.getItem("customRegisterForm");
  
  if(currentPath === "/" && localStorage.getItem("formRegister") === "true" && document.querySelector('div[data-customer]')){
    localStorage.setItem("registerSuccess", "true");
  }
  // Caso: Shopify nos redirige a /account/register con errores
  if (currentPath === "/account/register") {
    localStorage.setItem("formRegister", "true");

    const errorMessageElement = document.querySelector('#RegisterForm .form-status__message');

    if (customFormPath && errorMessageElement) {
      const errorMessage = errorMessageElement.innerHTML;
      localStorage.setItem("formStatusMessage", errorMessage);

      // Redirige al formulario personalizado con el error
      window.location.href = customFormPath;
    }

  } else {
    // Caso: estamos en otro sitio (formulario personalizado, home, etc.)

    // Si estamos en el formulario personalizado
    if (document.querySelector("form#RegisterForm")) {
      localStorage.setItem("formRegister", "true");

      // Mostrar error si venimos de fallo anterior
      if (customFormPath && currentPath === customFormPath) {
        const savedMessage = localStorage.getItem("formStatusMessage");
        if (savedMessage) {
          document.querySelector("form#RegisterForm").insertAdjacentHTML("afterbegin", savedMessage);
        }
      } else {
        // Limpieza si no estamos en la URL esperada
        localStorage.removeItem("customRegisterForm");
        localStorage.removeItem("formStatusMessage");
      }

    // Si estamos en la home, solo redirigimos si el registro fue exitoso
    } else if (
      currentPath === "/" &&
      localStorage.getItem("formRegister") === "true" &&
      localStorage.getItem("registerSuccess") === "true"
    ) {
      const lang = document.documentElement.getAttribute('lang') || 'es';

      // Limpieza total
      localStorage.removeItem("formRegister");
      localStorage.removeItem("registerSuccess");
      localStorage.removeItem("customRegisterForm");
      localStorage.removeItem("formStatusMessage");

      // Redirección a la página de gracias
      if (lang === "en") {
        window.location.href = "/en/pages/gracias-por-registrarte";
      } else if (lang === "ca") {
        window.location.href = "/ca/pages/gracias-por-registrarte";
      } else {
        window.location.href = "/pages/gracias-por-registrarte";
      }
    }
  }
  equalizeHeights(); // Ejecutar al cargar
  redirectOnClickVariant();
  // Vuelve a calcular las alturas si cambia el tamaño de la ventana
  window.addEventListener("resize", equalizeHeights);  
  setTimeout(() => {
    equalizeHeights(); // Ejecutar al cargar
  }, 1000); 
});